import React from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";


const PageHeader = (props) => {

    const { title, cover } = props;

    return (
        <div className="page-header">
            <Container>
                <Row>
                    <Col className="align-self-center text-center py-3" xs={12} md={12}>
                        {
                            !!title && <h2 className="page-title">{title}</h2>
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default PageHeader;